module.exports = __webpack_public_path__ + "img/desk-var-01.267776fa.png";